import { render, staticRenderFns } from "./VendorStatistics.vue?vue&type=template&id=94fba814&"
import script from "./VendorStatistics.vue?vue&type=script&lang=js&"
export * from "./VendorStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports